export const EnvironmentConfig = {
  appUrl: 'https://clinica.dentalbooking.ro',
  // appUrl: "https://dentalbooking.dev.creative-ones.com",
  // appUrl: 'https://dentbooking.codernapps.ro',
  // appUrl: "https://dentalbooking-backend.test",
};
